import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import retentionStyle from "../../Candidate/CandidateLeadTable/candidateLead.module.scss";
import {
  GetAllAdminDetails,
  getcandidateDetails,
  getCandidateLead,
  GetCanidateRetention,
  putretentionCan,
} from "../../../apiServices";
import { Container, Form, Table } from "react-bootstrap";
import {
  capitalizeWords,
  dateFormateDD,
  decryptedAdminID,
  formatDated,
  MyModal,
  textTruncate,
  textTruncates,
} from "../../../utility";
import style from "./CandidateRetentions.module.scss";
import {
  CandidateRetentionActions,
  commonPopupActions,
} from "../../../redux-store/store";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Pagination,
  TextField,
} from "@mui/material";
import { LuRefreshCcw } from "react-icons/lu";
import CandidateRententionFilter from "./CandidateRententionFilter";
import { BsThreeDotsVertical } from "react-icons/bs";
import ModalContainer from "../../../components/modal_popup";
import { MenuItem } from "react-bootstrap-typeahead";
import SuccessTick from "../../../components/success_tick";
import CryptoJS from "crypto-js";

const isWithinLastThreeDays = (date) => {
  const now = new Date();
  const joinedDate = new Date(date);
  const timeDifference = now - joinedDate;
  const threeDaysInMilliseconds = 3 * 24 * 60 * 60 * 1000;
  return timeDifference <= threeDaysInMilliseconds;
};
// console.log(isWithinLastThreeDays, "isWithinLastThreeDays");

function CandidateRetention() {
  const Dispatch = useDispatch();
  const candidateRetentionsFilter = useSelector(
    (state) => state.CandidateRetentionDetails.retentionsFilter
  );
  const canRetentionSize = useSelector(
    (state) => state.CandidateRetentionDetails.size
  );

  const [canInterviewsID, setcanInterviewsID] = useState("");
  const [canRetentiondData, setCanRetentiondData] = useState({
    retentionData: [],
    totalpage: "",
    totalElement: "",
    currenpage: 1,
  });
  const calculateTotalPages = (totalElements, elementsPerPage) => {
    return Math.ceil(totalElements / elementsPerPage);
  };
  const [textFieldValue, setTextFieldValue] = useState("");
  const [enableSubmit, setenableSubmit] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState("");
  const [error, setError] = useState("");
  const [rentionpopup, setRentionPopup] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetailsRole.roleID === 1;
  const secretKey = "your-secret-key";
  const admin = decryptedAdminID();
  if (admin) {
    // Decrypt the admin ID
    const bytes = CryptoJS.AES.decrypt(admin, secretKey);
    const decryptedAdminID = bytes.toString(CryptoJS.enc.Utf8);

    // console.log("Decrypted Admin ID:", decryptedAdminID);
  }

  const initialState = {
    // assignTo: isSuperAdmin == 1 ? -1 : decryptedAdminID(),
    // assignTo: isSuperAdmin === 1 ? -1 : decryptedAdminID() || -1,
    assignTo: admin == 1 ? -1 : admin,

    // assignTo: -1,
    status: "",
    issueFaced: "",
    resolved: "",
    weekStatus: "",
    mobileNumber: "",
    joinedDate: "",
    companyName: "",
    page: 0,
    size: 120,
  };
  useEffect(() => {}, [candidateRetentionsFilter]);

  useEffect(() => {
    setShowLoader(true);
    GetCanidateRetention(candidateRetentionsFilter)
      .then((data) => {
        console.log(data, "candidateRetentionsFilter");

        // Get today's date in YYYY-MM-DD format
        const today = new Date();
        const todayFormatted = formatDated(today);

        const groupedArray = [];
        for (let i = 0; i < data.data.length; i += 12) {
          groupedArray.push(data.data.slice(i, i + 12));
        }

        let filteredArray = groupedArray.map((arr) => {
          let array = arr.filter((el) => {
            const retentionDate = new Date(el.retention.date);
            const date = formatDated(retentionDate);
            return date <= todayFormatted;
          });

          return array.pop();
        });

        let flatenedArray = filteredArray.flat();

        console.log(flatenedArray, "Flattened Array");

        const totalEle = data.totalElements;
        const elementsPerPage = 12;
        const totalPages = calculateTotalPages(totalEle, elementsPerPage);

        setCanRetentiondData((prev) => ({
          ...prev,
          retentionData: flatenedArray,
          totalpage: data.totalPages,
          totalElement: totalPages,
        }));
      })
      .catch(() => {
        // alert("Something went wrong");
        setCanRetentiondData((prev) => ({
          ...prev,
          retentionData: [],
          totalpage: 1,
          totalElement: 0,
        }));
      })
      .finally(() => {
        setShowLoader(false);
      });
    GetAllAdminDetails()
      .then((data) => {
        const activeAdmins = data.filter(
          (item) => !item.Deactived && item.Module !== "Developer"
        );
        setAdminList(activeAdmins);
        console.log(activeAdmins, "activename");
      })
      .catch(() => {
        alert("Something went wrong");
      });
    console.log(candidateRetentionsFilter, "candidateRetentionsFilter");
  }, [candidateRetentionsFilter]);
  const getAdminUsername = (adminId) => {
    const admin = adminList.find((admin) => admin.id == adminId);
    console.log(admin, "admin");
    return admin ? admin.userName : "Taizo";
  };
  const handleCandidateDetails = async (candidateId, type) => {
    let data;
    if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateId);
    } else if (type === "CandidateLead") {
      data = await getCandidateLead(candidateId);
    }

    // Dispatch action to show the popup and pass the fetched data
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateId,
        type: type,
        data: data,
      })
    );
  };
  const handlePageChange = (event, pageNumber) => {
    console.log(pageNumber, "pageNumber");
    setCanRetentiondData((pre) => ({
      ...pre,
      currenpage: pageNumber,
    }));
    const page = pageNumber - 1;
    Dispatch(CandidateRetentionActions.setCanRetentionspage(page));
    // setfilterData((prev) => ({
    //   ...prev,
    //   page: pageNumber - 1,
    // }));
  };
  const handleSubmit = async () => {
    if (!dropdownValue) {
      setError(true);
      return;
    }
    setError(false);
    setenableSubmit(true);
    try {
      const canId = selectedCandidateId;
      const week = selectedWeek;
      await putretentionCan(canId, week, textFieldValue, dropdownValue);
      setShowSuccess(true);

      handleClose();
      setenableSubmit(false);
      setRentionPopup(false);
      handleReset();
      setTimeout(() => setShowSuccess(false), 2000);
    } catch (error) {
      console.error("Error submitting form", error);
    }
  };
  const candidateSize = (size) => {
    Dispatch(CandidateRetentionActions.setCanRetentionsSize(size));
  };
  const handleReset = () => {
    Dispatch(
      CandidateRetentionActions.setCanRetentionsFilter({
        assignTo: admin == 1 ? -1 : admin,
        status: "",
        issueFaced: "",
        resolved: "",
        weekStatus: "",
        mobileNumber: "",
        joinedDate: "",
        companyName: "",
        page: 0,
        size: 120,
      })
    );
  };
  const handleClose = () => {
    setRentionPopup(false);
    setDropdownValue("");
    setTextFieldValue("");
    setError("");
  };
  return (
    <>
      <div>
        <div className={`${retentionStyle.Topcontainer}`}>
          {" "}
          <div className="d-flex ">
            Show {"  "}
            <select
              name=""
              id=""
              className="px-1 py-1 mx-2"
              onChange={(event) => candidateSize(event.target.value)}
            >
              <option selected value="120">
                10
              </option>
              <option value="240">20</option>
              <option value="360">30</option>
            </select>
            {"   "}
            Entries
          </div>
          <div className={`${retentionStyle.filterAdduser}`}>
            <div className="mt-1 me-2">
              Total Count : {canRetentiondData.totalElement}
            </div>
            <div
              className="p-1 success  me-2 mx-2 ms-auto"
              onClick={handleReset}
              style={{ cursor: "pointer" }}
            >
              <LuRefreshCcw />
            </div>
            <CandidateRententionFilter />
          </div>
        </div>
        <div style={{ height: "64vh", overflowY: "auto" }}>
          <Table hover>
            <thead className={style.header}>
              <tr>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Company Name</th>
                <th>Retention Status</th>
                <th>Joined Date</th>
                {isSuperAdmin && <th>Assigned To</th>}
                <th>Issue Faced</th>
                <th>Week</th>
                <th align="right">Weekly Update</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(canRetentiondData.retentionData) &&
              canRetentiondData.retentionData.length > 0 ? (
                canRetentiondData.retentionData.map((candidate, index) => (
                  <tr key={index}>
                    <td
                      className="text-primary"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleCandidateDetails(
                          candidate.candidate.id,
                          "RegisterCandidate"
                        )
                      }
                    >
                      {candidate.candidate.firstName ?? "-"}{" "}
                      {candidate.candidate.lastName ?? ""}
                    </td>
                    <td>{candidate.candidate.mobileNumber ?? "-"}</td>
                    <td title={candidate.interview.companyName}>
                      {/* {candidate.interview.companyName ?? "-"} */}
                      {candidate.interview.companyName
                        ? textTruncate(
                            capitalizeWords(candidate.interview.companyName),
                            15
                          )
                        : "-"}
                    </td>
                    <td>{candidate.retention.status ?? "-"}</td>
                    <td>
                      {candidate.candidate.joinedConfirmedAt
                        ? dateFormateDD(candidate.candidate.joinedConfirmedAt)
                        : "-"}
                    </td>
                    {isSuperAdmin && (
                      <td>
                        {candidate.interview.adminId
                          ? getAdminUsername(candidate.interview.adminId)
                          : "-"}
                      </td>
                    )}
                    <td title={candidate.retention.issueFaced}>
                      {candidate.retention.issueFaced
                        ? textTruncate(
                            capitalizeWords(candidate.retention.issueFaced),
                            15
                          )
                        : "-"}
                    </td>
                    <td>
                      {candidate.retention.week ? (
                        <span
                          // className="bg-secondary border border-1 rounded-pill px-3"
                          style={{
                            border: "2px solid #bfc9ca",
                            backgroundColor: "#eaeded",
                            fontSize: "12px",
                            borderRadius: "8px",
                            marginRight: "18px",
                            padding: "0px 10px",
                          }}
                        >
                          <b>{candidate.retention.week} week</b>
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                    {/* {console.log(
                      isWithinLastThreeDays(
                        candidate.candidate.joinedConfirmedAt
                      )
                    )} */}
                    <td>
                      {isWithinLastThreeDays(
                        candidate.candidate.joinedConfirmedAt
                      ) ? (
                        "-"
                      ) : (
                        <div style={{ textAlign: "left" }}>
                          {candidate.retention.status == null ? (
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <span
                                  style={{
                                    border: "2px solid #9B59B6",
                                    backgroundColor: "#EBDEF0",
                                    fontSize: "12px",
                                    borderRadius: "8px",
                                    marginRight: "18px",
                                    padding: "2px",
                                  }}
                                >
                                  Action required
                                </span>
                              </div>
                              <div className="dropdown">
                                <span
                                  style={{ cursor: "pointer" }}
                                  id="dropdownMenuButton1"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <BsThreeDotsVertical />
                                </span>
                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1"
                                >
                                  <li
                                    onClick={() => {
                                      setRentionPopup(true);
                                      setcanInterviewsID(
                                        candidate.interview.id
                                      );
                                      setSelectedCandidateId(
                                        candidate.candidate.id
                                      );
                                      setSelectedWeek(candidate.retention.week);
                                    }}
                                  >
                                    <a className="dropdown-item" href="#">
                                      Candidate Status
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          ) : (
                            <span
                              style={{
                                border: "2px solid yellow",
                                backgroundColor: "lightyellow",
                                fontSize: "12px",
                                borderRadius: "8px",
                                marginRight: "18px",
                                padding: "2px",
                              }}
                            >
                              Already updated
                            </span>
                          )}
                        </div>
                      )}{" "}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="10"
                    className="text-center"
                    style={{ color: "#CD1655" }}
                  >
                    <b>No data available</b>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <div>
          <Pagination
            shape="rounded"
            color="success"
            boundaryCount={1}
            siblingCount={1}
            onChange={handlePageChange}
            count={canRetentiondData.totalpage}
            page={canRetentiondData.currenpage}
            size="small"
          />
        </div>
      </div>
      {rentionpopup && (
        <MyModal>
          <ModalContainer
            childComponent={
              <div
                style={{
                  // padding: "20px",
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: "400px",
                }}
              >
                <div className="text-center mb-2">
                  <b>Candidate status </b>
                </div>
                <Form.Group
                  className="mb-2"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>Please type the issue (optional) :</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={textFieldValue}
                    onChange={(e) => setTextFieldValue(e.target.value)}
                    // onError={error && !textFieldValue.trim()}
                  />
                  {/* <Form.Text>
                    {error && !textFieldValue.trim() && (
                      <span className="text-danger">
                        This field is required
                      </span>
                    )}
                  </Form.Text> */}
                </Form.Group>

                <div className="form-group mt-2">
                  <label htmlFor="" className="mb-1">
                    Select candidate status :
                  </label>
                  <select
                    id="action-select"
                    className={`form-control ${
                      error && !dropdownValue ? "is-invalid" : ""
                    }`}
                    value={dropdownValue}
                    onChange={(e) => {
                      setDropdownValue(e.target.value);
                      if (error) {
                        setError(false);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <option value="" selected disabled>
                      choose an option
                    </option>
                    <option value="Active">Active</option>
                    <option value="Left Company">Left Company</option>
                  </select>
                  {error && !dropdownValue && (
                    <div className="invalid-feedback">
                      This field is required
                    </div>
                  )}
                </div>
                <div className="d-flex align-items-center justify-content-end mt-2 gap-2">
                  <Button
                    variant="outlined"
                    onClick={handleClose}
                    color="error"
                    // style={{ marginTop: "10px", marginLeft: "10px" }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleSubmit}
                    color="success"
                    disabled={enableSubmit}
                    // style={{ marginTop: "10px" }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            }
          />
        </MyModal>
      )}
      {showSuccess && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <SuccessTick HeadText={"Successfully"} />
              </>
            }
          />
        </MyModal>
      )}
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={showLoader}
        onClick={() => {}} // Prevent closing on backdrop click
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default CandidateRetention;
